import type { TFunction } from 'i18next';

/**
 * Объём данных человеку.
 *
 * Отдельным модулем, а не рядом с панелью: файл, экспортирующий и компонент,
 * и обычную функцию, Vite не обновляет горячей заменой — он перезагружает
 * его целиком, и оболочка на секунду замирает при каждой правке.
 *
 * Единица приходит из словаря, а не пишется здесь: «КБ» и «KB» отличаются
 * не только буквами — в русском и английском разная и точка после сокращения,
 * и место единицы относительно числа в некоторых языках. Само число
 * форматирует `Intl` внутри словаря (`{{value, number}}`): разделитель
 * дробной части у языков разный.
 */
export function formatBytes(bytes: number, t: TFunction): string {
  if (bytes < 1024) {
    return t('common.bytes.b', { value: bytes });
  }
  if (bytes < 1024 ** 2) {
    return t('common.bytes.kb', { value: Number((bytes / 1024).toFixed(0)) });
  }
  if (bytes < 1024 ** 3) {
    return t('common.bytes.mb', { value: Number((bytes / 1024 ** 2).toFixed(1)) });
  }
  // Гигабайты появились вместе с файловым обменом (фаза 6): образы
  // и резервные копии на удалённых машинах измеряются именно ими,
  // а «5432.1 МБ» в списке файлов читать невозможно. Терабайты не нужны:
  // предел на одну передачу — два гигабайта, а размеры в списке приходят
  // от файловой системы, где терабайтный файл — редкость, которую честнее
  // показать четырёхзначным числом гигабайт, чем ещё одной единицей.
  return t('common.bytes.gb', { value: Number((bytes / 1024 ** 3).toFixed(2)) });
}
